const o = (r) => ({ queryKey: e }) => {
  const [n, ...t] = e;
  return r(...t);
};
export {
  o as queryify
};
